import type { RouteRecordRaw } from 'vue-router';
import headerRoutes from '@/modules/header/header.routes.children';
import { prefixRouteNames } from '@/shared/utils/routes';
import { useEnvironmentStore } from '@/shared/stores/environment.store';
import { useWorkspaceStore } from '@/shared/stores/workspace.store';

export default [
    {
        path: ':workspaceId/workspace',
        name: 'workspace',
        component: () => import('./components/WorkspaceContent.vue'),
        meta: {
            title: 'Workspace',
        },
        children: [
            {
                path: 'create-folder-edc/:fatherId',
                name: 'create-folder-edc',
                component: () => import('./modals/Create/CreateFolderEdc/CreateFolderEdcModal.vue'),
                meta: {
                    modal: true,
                },
            },
            {
                path: 'workspace-create-folder/:fatherId',
                name: 'workspace-create-folder',
                component: () => import('./modals/Create/CreateFolder/CreateFolderModal.vue'),
                meta: {
                    modal: true,
                },
            },
            {
                path: 'rename-item/:keyPath',
                name: 'rename-item',
                component: () => import('./modals/Actions/RenameItem/RenameItemModal.vue'),
                meta: {
                    modal: true,
                },
            },
            {
                path: 'create-pending-document/:fatherId',
                name: 'create-pending-document',
                component: () => import('./modals/Create/CreatePendingDocument/CreatePendingDocumentModal.vue'),
                meta: {
                    modal: true,
                },
            },
            {
                path: 'export-zip',
                name: 'export-zip',
                component: () => import('./modals/Export/ExportZip/ExportZipModal.vue'),
                meta: {
                    modal: true,
                },
            },
            {
                path: 'export-excel',
                name: 'export-excel',
                component: () => import('./modals/Export/ExportExcel/ExportExcelModal.vue'),
                meta: {
                    modal: true,
                },
            },
            {
                path: 'create-link-url/:fatherId',
                name: 'create-link-url',
                component: () => import('./components/modals/CreateLinkUrl.vue'),
                meta: {
                    modal: true,
                },
            },
            {
                path: 'notification',
                name: 'notification',
                component: () => import('./modals/Notification/NotificationModal.vue'),
                meta: {
                    modal: true,
                },
            },
            {
                path: 'duplication-folder/:folderId',
                name: 'duplication-folder',
                component: () => import('./modals/Actions/DuplicationFolder/DuplicationFolderModal.vue'),
                meta: {
                    modal: true,
                },
            },
            {
                path: 'delete-item/:itemId/:itemType',
                name: 'delete-item',
                component: () => import('./modals/Actions/DeleteItem/DeleteItemModal.vue'),
                meta: {
                    modal: true,
                },
            },
            {
                path: 'restore/:itemId',
                name: 'restore',
                component: () => import('./modals/Actions/Restore/RestoreModal.vue'),
                meta: {
                    modal: true,
                },
            },
            {
                path: 'move/:itemId',
                name: 'move',
                component: () => import('./modals/Actions/Move/MoveModal.vue'),
                meta: {
                    modal: true,
                },
            },
            {
                path: 'deposit/:folderId',
                name: 'deposit',
                props: true,
                component: () => import('./modals/Deposit/DepositModal.vue'),
                meta: {
                    modal: true,
                },
            },
            {
                path: 'viewer',
                name: 'viewer',
                components: {
                    viewerSlot: () => import('@/shared/blocksUI/viewer/AxIFrameViewer.vue'),
                },
                beforeEnter: (to, from, next) => {
                    if (to.query.rowForDetails || to.query.accordionForDetails) {
                        return next({
                            name: to.name,
                            params: to.params,
                            query: {
                                ...to.query,
                                rowForDetails: undefined,
                                accordionForDetails: undefined,
                            },
                        });
                    }

                    return next();
                },
            },
            {
                path: 'see-workflow/:keyPath',
                name: 'see-workflow',
                component: () => import('./modals/Actions/WorkflowZoom/WorkflowZoomModal.vue'),
                meta: {
                    modal: true,
                },
            },
            {
                path: 'workflow-actions/:itemId/:missionId',
                name: 'workflow-actions',
                component: () => import('./modals/Actions/WorkflowZoom/WorkflowActionsModal.vue'),
                meta: {
                    modal: true,
                },
            },
            {
                path: 'workflow-multiple-files-actions/:missionId',
                name: 'workflow-multiple-files-actions',
                component: () => import('./modals/Actions/WorkflowZoom/WorkflowMultipleFilesActionsModal.vue'),
                meta: {
                    modal: true,
                },
            },
            {
                path: 'viewer-download/:gedItemId',
                name: 'viewer-download',
                component: () => import('./modals/Actions/DownloadItem/DownloadItemModal.vue'),
                meta: {
                    modal: true,
                },
            },
            {
                path: 'version-history',
                name: 'version-history',
                component: () => import('./modals/Details/VersionHistory/VersionHistory.vue'),
                meta: {
                    modal: true,
                },
            },
            ...prefixRouteNames('workspace', headerRoutes),
        ],
        beforeEnter: (to) => {
            const workspaceStore = useWorkspaceStore();
            const environmentStore = useEnvironmentStore();
            const workspaces = environmentStore.workspaces;
            const currentWorkspace = workspaces?.find((workspace) => workspace.id === Number(to.params.workspaceId));

            if (currentWorkspace) {
                workspaceStore.setCurrentWorkspace({
                    id: currentWorkspace.id,
                    key: currentWorkspace.id.toString(),
                    keyPath: ['root', currentWorkspace.id.toString()],
                    workspace: currentWorkspace.id,
                    label: currentWorkspace.name,
                    lca: currentWorkspace.lca,
                });
            }
        },
    },


] satisfies RouteRecordRaw[];
